import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css'
import './App.css';
import {Component} from "react";


class App extends Component {
    static defaultState = {
        name: '',
        func: '',
        email: '',
        phoneText: '020 820 8916',
        phoneLink: '+31208208916',
        image: ''
    }

    constructor(props) {
        super(props);
        this.state = App.defaultState;
        this.handleChange = this.handleChange.bind(this);
        this.mediaUrl = 'https://littlesheepanimatie.nl/media/mail';
    }

    handleChange(partialState) {
        this.setState(partialState);
    }

    render() {
        const signature = `<link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;700&display=swap" rel="stylesheet">
<style type="text/css">
    * {
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }
    :root {
        color-scheme: light dark;
        supported-color-schemes: light dark;
    }
    @media (prefers-color-scheme: dark) {
        table#signature span,
        table#signature a {
            color: #ffffff !important;
        }
        table#signature td {
            border-color: #ffffff !important;
        }
    }
</style>
<table cellspacing="0" border="0" cellpadding="0" id="signature">
    <tbody>
    <tr>
        <td colspan="2" style="border-bottom: 1px solid #252543; padding-bottom: 8px;">
            <span style="font-family: 'DM Sans', Arial, sans-serif; font-size: 22px; font-weight: bold; color: #252543;">${this.state.name}</span>
            <span>&nbsp;</span>
            <span style="font-family: 'DM Sans', Arial, sans-serif; font-size: 16px; color: #252543;">${this.state.func}</span>
        </td>
    </tr>
    <tr>
        <td rowspan="2" style="vertical-align: top; padding-top: 15px; padding-right: 15px;">
            <img width="125" height="125" src=${this.state.image}>
        </td>
        <td height="78" style="padding-top: 15px; vertical-align: bottom;">
                <span style="font-family: 'DM Sans', Arial, sans-serif; font-size: 13px; line-height: 24px;">
                    <a href="https://littlesheepanimatie.nl" style="text-decoration: none; color: #252543;">littlesheepanimatie.nl</a>
                </span><br>
            <span style="font-family: 'DM Sans', Arial, sans-serif; font-size: 13px; line-height: 24px;">
                    <a href="mailto:${this.state.email}" style="text-decoration: none; color: #252543;">${this.state.email}</a>
                </span><br>
            <span style="font-family: 'DM Sans', Arial, sans-serif; font-size: 13px; line-height: 24px;">
                    <a href="tel:${this.state.phoneLink}" style="text-decoration: none; color: #252543;">${this.state.phoneText}</a>
                </span><br>
        </td>
    </tr>
    <tr>
        <td style="vertical-align: top; padding-top: 15px;">
            <a href="https://www.facebook.com/littlesheepanimatie" style="text-decoration: none; border: none;">
                <img src="${this.mediaUrl}/Facebook.png"
                     width="20" height="20"/>
            </a>
            <a href="https://www.instagram.com/little.sheep.animation/" style="text-decoration: none; border: none;">
                <img src="${this.mediaUrl}/Instagram.png"
                     width="20" height="20"/>
            </a>
            <a href="https://www.linkedin.com/company/little-sheep-animatie-studio/" style="text-decoration: none; border: none;">
                <img src="${this.mediaUrl}/LinkedIn.png"
                     width="20" height="20"/>
            </a>
            <a href="https://www.youtube.com/channel/UCuv2dzzgX-o8EA_MR9rd3vw"
               style="text-decoration: none; border: none;">
                <img src="${this.mediaUrl}/YouTube.png"
                     width="20" height="20"/>
            </a>
        </td>
    </tr>
    </tbody>
</table>`

        return (
            <div className="container">
                <div class="row">
                    <div class="col mt-4 mt-lg-5">
                        <h1 class="lss-heading">Little Sheep - Handtekening genereren</h1>
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-lg-4">
                        <Form currentState={this.state} changeHandler={this.handleChange}></Form>
                    </div>
                    <div className="col-lg-8 mt-3 mb-4 my-lg-0">
                        <Preview signature={signature}/>
                        <Code signature={signature}/>
                        <Explanation/>
                    </div>
                </div>
            </div>
        );
    }
}

class Form extends Component {
    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.resetForm = this.resetForm.bind(this);

    }

    handleChange(event) {
        this.props.changeHandler({[event.target.name]: event.target.value})
    }

    resetForm() {
        this.props.changeHandler(App.defaultState);
    }

    render() {
        const {
            name,
            func,
            email,
            phoneText,
            phoneLink,
            image
        } = this.props.currentState;

        return (
            <div className="card h-100">
                <div className="card-header fw-bold">
                    Gegevens
                    <i className="lss-icon-button bi-arrow-repeat float-end" title="Begin opnieuw" role="button" onClick={this.resetForm}></i>
                </div>
                <div className="card-body">
                    <form method="get">
                        <div className="mb-3">
                            <label htmlFor="name" className="form-label">Naam</label>
                            <input type="text" className="form-control" id="name" name="name" placeholder="Meneer Schaap"
                                   value={name} onChange={this.handleChange} required/>
                        </div>
                        <div className="mb-3">
                            <label htmlFor="func" className="form-label">Functie</label>
                            <input type="text" className="form-control" id="func" name="func" placeholder="Schaap"
                                   value={func} onChange={this.handleChange} required/>
                        </div>
                        <div className="mb-3">
                            <label htmlFor="email" className="form-label">E-mailadres</label>
                            <input type="email" className="form-control" id="email" name="email" value={email}
                                   onChange={this.handleChange} placeholder="naam@littlesheepanimatie.nl" required/>
                        </div>
                        <div className="mb-3">
                            <label htmlFor="phone" className="form-label">Telefoonnummer (zichtbaar)</label>
                            <input type="text" className="form-control" id="phone" name="phoneText"
                                   placeholder="012 345 6789"
                                   value={phoneText} onChange={this.handleChange} required/>
                            <div className="form-text">Het telefoonnummer in een leesbaar formaat.</div>
                        </div>
                        <div className="mb-3">
                            <label htmlFor="phone" className="form-label">Telefoonnummer (link)</label>
                            <input type="text" className="form-control" id="phone" name="phoneLink"
                                   placeholder="+31123456789"
                                   value={phoneLink} onChange={this.handleChange} required/>
                            <div className="form-text">Het telefoonnummer met kengetal (+31) en zonder spaties.</div>
                        </div>
                        <div className="mb-3">
                            <label htmlFor="image" className="form-label">URL portret</label>
                            <input type="tel" className="form-control" id="image" name="image"
                                   placeholder="https://littlesheepanimatie.nl/wp-content/uploads/..." value={image}
                                   onChange={this.handleChange} required/>
                            <div className="form-text">
                                Afbeelding kan worden overgenomen van de <a href="https://littlesheepanimatie.nl/over-ons/"
                                                                            target="_blank" rel="noreferrer"
                                                                            className="text-reset">website</a>.
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        )
    }
}

function Preview(props) {
    return (
        <div className="card">
            <div className="card-header fw-bold">
                Voorbeeld
            </div>
            <div className="card-body" dangerouslySetInnerHTML={{__html: props.signature}}/>
        </div>
    )
}

class Code extends Component {
    constructor(props) {
        super(props);

        this.copySignature = this.copySignature.bind(this);
    }

    copySignature(event) {
        const iconIdle = 'bi-clipboard-fill';
        const iconDone = 'bi-clipboard-check-fill';
        navigator.clipboard.writeText(this.props.signature).then(function () {
            event.target.classList.remove(iconIdle);
            event.target.classList.add(iconDone, 'text-success');
            setTimeout(() => {
                event.target.classList.remove(iconDone, 'text-success');
                event.target.classList.add(iconIdle);
            }, 1500);
        });
    }

    render() {
        return (
            <div className="card mt-3 lss-code">
                <div className="card-header fw-bold">
                    HTML-code
                    <i className="lss-icon-button bi-clipboard-fill float-end" title="Kopieer HTML" role="button" onClick={this.copySignature}></i>
                </div>
                <div className="card-body">
                    <pre>
                        <code>
                            {this.props.signature}
                        </code>
                    </pre>
                </div>
            </div>
        )
    }
}

function Explanation(props) {
    return (
        <div className="card mt-3">
            <div className="card-header fw-bold">
                Uitleg
            </div>
            <div className="card-body">
                <ol>
                    <li>Vul alle velden in en controleer het voorbeeld.</li>
                    <li>Kopieer de HTML-code via het <i className="bi-clipboard-fill"></i> icoon.</li>
                    <li>Stel deze in als handtekening via je e-mailprogramma.</li>
                </ol>
                <em>Kopieer altijd de HTML-code en niet het voorbeeld. Dan ondersteunt de handtekening ook dark mode.</em>
            </div>
        </div>
    )
}

export default App;
